import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
Vue.use(Vuex);

function getSaleLocalStorage(key, defaultValue) {
  try {
    return JSON.parse(localStorage.getItem(key))
  } catch (e) {
    return defaultValue;
  }
}

export default new Vuex.Store({
  state: {
    company:  getSaleLocalStorage("company", []),
    brand:  getSaleLocalStorage("brand", []),
    allUserList:  getSaleLocalStorage("allUserList", []),
    selectOrderIds: [],
    pageCount: {
      paymentCount: 0, //付款中订单数量
      toBeConfirmedCount: 0, //待确认订单数量
      paidCount: 0, //已付款订单数量
    },
  },
  mutations: {
    setCompany(state, company) {
      state.company = company;
      localStorage.setItem("company", JSON.stringify(company));
    },
    setBrand(state, brand) {
      state.brand = brand;
      localStorage.setItem("brand", JSON.stringify(brand));
    },
    setAllUserList(state, allUserList) {
      state.allUserList = allUserList;
      localStorage.setItem("allUserList", JSON.stringify(allUserList));
    },
    setSelectOrderIds(state, selectOrderIds) {
      state.selectOrderIds = selectOrderIds;
    },
    setPageCount(state, pageCount) {
      state.pageCount = { ...pageCount };
    },
  },
  actions: {
    async setPaymentCount({ commit }) {
      try {
        const res = await axios.post(
          `/v1/web/settlement-manage/settlement-order/listStatusCount`
        );
        commit("setPageCount", res.data.data);
      } catch (error) {
        console.error(error);
      }
    },
    async setCompany({ commit }) {
      try {
        const res = await axios.get(
          `/v1/web/company-manager/select-company-drown`
        );
        commit("setCompany", res.data.data);
      } catch (error) {
        console.error(error);
      }
    },
    async setBrand({ commit }) {
      try {
        const res = await axios.get(`/v1/web/device-brand/select-device-brand`);
        commit("setBrand", res.data.data.list);
      } catch (error) {
        console.error(error);
      }
    },
    async setAllUserList({ commit }) {
      try {
        const res = await axios.get(`/v1/web/user-info/select-master-drown`);
        let list = res.data.data.list;
        let newList = [];
        for (let i = 0; i < list.length; i++) {
          list[i].userName = list[i].userName.substring(
            0,
            list[i].userName.indexOf("(")
          );
          newList.push(list[i]);
        }
        commit("setAllUserList", newList);
      } catch (error) {
        console.error(error);
      }
    },
  },
});
